import { theme } from '@salecycle/ui-component-library';

export enum Fills {
  DEFAULT = 'default',
  WARNING = 'warning',
  ERROR = 'error',
}

interface IProps {
  fill: Fills;
}

export function UploadStatusSvg({ fill }: IProps) {
  let backTone;
  let frontTone;

  switch (fill) {
    case Fills.WARNING:
      backTone = theme.vars.newColor.gold4;
      frontTone = theme.vars.newColor.gold1;
      break;
    case Fills.ERROR:
      backTone = theme.vars.newColor.red4;
      frontTone = theme.vars.newColor.red1;
      break;
    default:
      backTone = theme.vars.newColor.purple4;
      frontTone = theme.vars.newColor.purple2;
  }

  return (
    <svg style={{ width: '275px' }} fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 279 286">
      <path stroke="#D6DEEA" strokeDasharray="5 5" d="M99.5 98.5h80v121h-80z" />
      <path
        d="M106.012 42c0-11.046 8.954-20 20-20h28.662c11.046 0 20 8.954 20 20v2.608h-68.662V42zm69.5 0c0-11.046 8.954-20 20-20h28.662c11.046 0 20 8.954 20 20v2.608h-68.662V42z"
        fill="#F5F7FA"
      />
      <g filter="url(#UploadStatusSvgFilter0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54 22c-11.046 0-20 8.954-20 20v119h190.175c11.045 0 20-8.954 20-20V42.934H104.337V42c0-11.046-8.954-20-20-20H54z"
          fill="#fff"
        />
      </g>
      <g filter="url(#UploadStatusSvgFilter1)">
        <path fill="#fff" d="M140.344 59.681h87.119v10.585h-87.119z" />
      </g>
      <path fill={backTone} d="M140.344 78.102h87.119v10.585h-87.119z" />
      <g filter="url(#UploadFilterSvgFilter2)">
        <ellipse cx="139.883" cy="220.226" rx="18.883" ry="19.226" fill={backTone} />
      </g>
      <path
        d="M146.862 219.447c.127-.351.223-.702.223-1.117a3.064 3.064 0 00-3.064-3.064c-.638 0-1.245.191-1.724.542a5.072 5.072 0 00-4.404-2.585 5.101 5.101 0 00-5.107 5.107v.287c-1.788.606-3.064 2.33-3.064 4.309a4.577 4.577 0 004.596 4.596h11.746a4.093 4.093 0 004.085-4.085c0-1.947-1.404-3.607-3.287-3.99zm-4.469 2.043l-.351.351a.762.762 0 01-1.085-.032l-1.022-1.085v3.989a.756.756 0 01-.766.766h-.51a.737.737 0 01-.766-.766v-3.989l-1.054 1.085a.762.762 0 01-1.085.032l-.351-.351c-.319-.32-.319-.798 0-1.086l2.968-2.968a.753.753 0 011.054 0l2.968 2.968c.319.288.319.766 0 1.086z"
        fill={frontTone}
      />
      <defs>
        <filter
          id="UploadStatusSvgFilter0"
          x="0"
          y="0"
          width="278.175"
          height="207"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="12" />
          <feGaussianBlur stdDeviation="17" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.403922 0 0 0 0 0.898039 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="UploadStatusSvgFilter1"
          x="125.344"
          y="49.681"
          width="117.119"
          height="40.585"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="7.5" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0.403922 0 0 0 0 0.898039 0 0 0 0.1 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <filter
          id="UploadFilterSvgFilter2"
          x="87"
          y="179"
          width="105.765"
          height="106.452"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feDropShadow dy="12" stdDeviation="17" floodColor={backTone} />
        </filter>
      </defs>
    </svg>
  );
}
